import { schemeHeaderColors } from '%evp_theme/brandbook/v20/tokens';
import { APPEARANCE_SCHEME_ATTRIBUTE, isDarkScheme } from './appearanceSchemes';

const THEME_COLOR_SELECTOR = 'meta[name="theme-color"]';

export default function applyAppearanceToDocument(targetDocument, scheme) {
    const root = targetDocument.documentElement;

    root.setAttribute(APPEARANCE_SCHEME_ATTRIBUTE, scheme);
    root.style.colorScheme = isDarkScheme(scheme) ? 'dark' : 'light';
    targetDocument.querySelectorAll(THEME_COLOR_SELECTOR).forEach((meta) => {
        meta.setAttribute('content', schemeHeaderColors[scheme]);
    });
}
